import { ParentProps, ValidComponent } from "solid-js";
import Dropdown from "../../st-dropdown/st-dropdown";
import { DropdownTriggerProps } from "../../st-dropdown/fragments/DropdownTrigger";
import { requireSelectContext } from "../SelectContext";

export function SelectTrigger<T extends ValidComponent = 'div'>(props: ParentProps<DropdownTriggerProps<T>>) {
    const ctx = requireSelectContext();
    ctx.hasTrigger = true;

    return <Dropdown.Trigger {...props} />
}
